import React from 'react';
import Skeleton from 'react-loading-skeleton';
export default (function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { colSpan: 100 },
                    React.createElement(Skeleton, null))))));
});
